<template>
  <div>
    <CRow>
      <CCol class="ml-2">
        <h3 class="topicText mt-3 mb-0">Popular courses</h3>
      </CCol>
    </CRow>
    <br />
    <div class="containerDanger">
      <!-- <div class="left" id="left-button-free" @click="swipeLeftFree" v-if="popCourses[0].courses.length >= 7">
        <img style="object-fit: cover; height: 100%; width: 100%" src="@/assets/icons/Previous.svg" />
      </div>-->
      <div class="wrapper pl-3" id="content-free" ref="contentFree">
        <div v-for="(item, index) in popCourses" :key="index">
          <div class="itemC" v-for="(courses,indexCourse) in item.courses" :key="indexCourse">
            <div :class="['animatedBox', {'active': selectedIndexCard.includes(indexCourse)}]">
              <!-- <courseCardDefault
                @move="move"
                @tellMeWhenYouReady="tellMeWhenYouReady"
                :index="indexCourse"
                :animationTesting="animationTesting"
                :data="courses"
                @courseData="returnData"
              />-->
              <mdlCard
                :data="courses"
                type="normal"
                :index="indexCourse"
                
              />
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="right" id="right-button" @click="swipeRightFree" v-if="popCourses[0].courses.length >= 7">
        <img style="object-fit: cover; height: 100%; width: 100%" src="@/assets/icons/Next.svg" />
      </div>-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import mdlCard from "../../showSingleCard/MdlCard";

import courseCardDefault from "../../showSingleCard/HomeCourseCardDefault";
export default {
  name: "index",
  props: {
    popCourses: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      signalForAnimated: false,
      selectedIndexCard: [],
      animationTesting: false,
    };
  },
  components: {
    courseCardDefault,
    mdlCard,
  },
  mounted() {
  },
  methods: {
    move(index) {
      if (this.selectedIndexCard.includes(index)) {
        this.selectedIndexCard.splice(this.selectedIndexCard.indexOf(index), 1);
      } else {
        this.selectedIndexCard.push(index);
      }
    },
    tellMeWhenYouReady() {
      this.signalForAnimated = !this.signalForAnimated;
    },
    viewAllHandler() {
      alert("Go to view all page");
    },
    returnData(data) {
      this.$emit("returndata", data);
    },
    swipeLeftFree() {
      const content = this.$refs.contentFree;
      this.scrollTo(content, -300, 800);
    },
    swipeRightFree() {
      const content = this.$refs.contentFree;
      this.scrollTo(content, 300, 800);
    },
    scrollTo(element, scrollPixels, duration) {
      const scrollPos = element.scrollLeft;
      // Condition to check if scrolling is required
      if (
        !(
          (scrollPos === 0 || scrollPixels > 0) &&
          (element.clientWidth + scrollPos === element.scrollWidth ||
            scrollPixels < 0)
        )
      ) {
        // Get the start timestamp
        const startTime =
          "now" in window.performance
            ? performance.now()
            : new Date().getTime();

        function scroll(timestamp) {
          //Calculate the timeelapsed
          const timeElapsed = timestamp - startTime;
          //Calculate progress
          const progress = Math.min(timeElapsed / duration, 1);
          //Set the scrolleft
          element.scrollLeft = scrollPos + scrollPixels * progress;
          //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
          if (timeElapsed < duration) {
            //Request for animation
            window.requestAnimationFrame(scroll);
          } else {
            return;
          }
        }

        //Call requestAnimationFrame on scroll function first time
        window.requestAnimationFrame(scroll);
      }
    },
  },
  created() {},
  computed: {},
  watch: {
    selectedIndexCard: function () {
      // alert('Hi')
      this.tellMeWhenYouReady();
    },
    signalForAnimated: function () {
      if (this.signalForAnimated) {
        // alert('Let\'s go for animation');
        this.animationTesting = true;
      } else {
        this.animationTesting = false;
      }
    },
  },
};
</script>

<style scoped>
.animatedBox {
  cursor: pointer;
  /* margin-right: 3px; */
  transition: margin 0.4s ease-out;
}

.animatedBox.active {
  margin-right: 0.8rem;
}
/* container for store cards */
.containerDanger {
  margin-left: 4rem;
  padding-right: 4rem;
  position: relative;
  width: 100%;
  height: 220px;
}

.containerDanger .wrapper {
  float: left;
  width: 100%;
  /* height: 100%; */
  margin: 1px;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  overflow-x: auto;
}

.containerDanger .wrapper .viewAllIconContainer {
  text-align: center;
  /* height: 220px; */
  /* line-height: 220px; */
  line-height: 17rem;
}

.containerDanger .wrapper .viewAllIconContainer img {
  /*vertical-align: middle;*/
}

.containerDanger .wrapper .viewAllIconContainer:hover {
  cursor: pointer;
}

.containerDanger .wrapper::-webkit-scrollbar {
  display: none;
}

.containerDanger .wrapper .itemC {
  /* height: 100%; */
  bottom: 0;
  display: inline-block;
}

.containerDanger .left {
  text-align: center;
  z-index: 1;
  position: absolute;
  left: 0;
  width: 3%;
  height: 105%;
  margin-top: 1.1rem;
  color: white;
  background: black;
  opacity: 0.2;
}

.containerDanger .right {
  text-align: center;
  z-index: 1;
  position: absolute;
  right: 3.75rem;
  width: 3%;
  height: 105%;
  margin-top: 1.1rem;
  color: white;
  background: black;
  opacity: 0.2;
}

.containerDanger .left:hover,
.containerDanger .right:hover {
  cursor: pointer;
  opacity: 0.6;
  background: grey;
  height: 105%;
}
@media only screen and (max-width: 600px) {
  .containerDanger {
    position: relative;
    width: 100%;
    height: 220px;
  }

  .containerDanger .left {
    width: 7%;
  }

  .containerDanger .right {
    width: 7%;
  }
}
.viewAllText {
  margin-top: auto;
  margin-bottom: -0.45rem !important;
}
.viewAllText:hover {
  cursor: pointer;
  /* padding-top: 0.5rem */
}
.viewAllImage {
  border-radius: 50%;
  opacity: 0.8;
  vertical-align: center;
}
.topicText {
  margin-left: 3.5rem;
  padding-left: 0.35rem;
  text-align: left;
  font: Bold 30px/39px Roboto;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  font-family: Roboto;
  font-weight: bold;
  margin-bottom: -1.5rem !important;
}
</style>
